(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  function removeOldSupportSections(root = document) {
    const descriptions = [];

    if (root.matches?.('.info_description')) {
      descriptions.push(root);
    }

    descriptions.push(
      ...root.querySelectorAll('.info_description')
    );

    descriptions.forEach((description) => {
      // Remove old support tables regardless of their contents.
      description.querySelectorAll('table').forEach((table) => {
        const text = table.textContent || '';

        if (
          /\bSpecifications\b/i.test(text) ||
          /\bInstallation Instructions\b/i.test(text)
        ) {
          const wrapper = table.closest('.table-responsive');

          if (wrapper && description.contains(wrapper)) {
            wrapper.remove();
          } else {
            table.remove();
          }
        }
      });

      // Remove standalone support headings and their associated content.
      const elements = [
        ...description.querySelectorAll('p, h2, h3, h4')
      ];

      elements.forEach((element) => {
        if (!element.isConnected) return;

        const title = element.textContent.trim();

        if (
  /^(Specifications|Installation Instructions|Downloads|Download Support)$/i.test(title)
) {
          const next = element.nextElementSibling;

          if (next) {
  const isDownloadContent =
    /^(Downloads|Download Support)$/i.test(title);

  if (
    isDownloadContent &&
    (
      next.matches('p, ul, ol, .table-responsive') ||
      next.querySelector('a[href]')
    )
  ) {
    next.remove();
  } else if (
    !isDownloadContent &&
    (
      next.matches('img, .table-responsive') ||
      next.querySelector('img')
    )
  ) {
    next.remove();
  }
}

          element.remove();
        }
      });
    });
  }

  function init(root = document) {
    removeOldSupportSections(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => init(),
      { once: true }
    );
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
  (() => {
    function initialiseVariantPicker(section) {
      if (section.dataset.variantPickerInitialized === 'true') return;

      const variantSelect = section.querySelector('[data-variant-select]');
      const optionSelectors = [...section.querySelectorAll('[data-variant-option]')];
      const variantData = section.querySelector('[data-product-variants]');
      if (!variantSelect || !optionSelectors.length || !variantData) return;

      let variants;
      try {
        variants = JSON.parse(variantData.textContent);
      } catch (error) {
        return;
      }

      if (!variants.every((variant) => Array.isArray(variant.options))) return;
      section.dataset.variantPickerInitialized = 'true';

      const selectedValues = () => optionSelectors.map((selector) => selector.value);
      const variantForValues = (values) => variants.find((variant) => (
        variant.options.length === values.length
        && variant.options.every((value, index) => value === values[index])
      ));

      function updateOptionAvailability() {
        const values = selectedValues();
        optionSelectors.forEach((selector, optionIndex) => {
          [...selector.options].forEach((option) => {
            option.disabled = !variants.some((variant) => (
              variant.options[optionIndex] === option.value
              && variant.options.every((value, index) => index === optionIndex || value === values[index])
            ));
          });
        });
      }

      function selectVariant(variant) {
        optionSelectors.forEach((selector, index) => {
          selector.value = variant.options[index];
        });
        variantSelect.value = String(variant.id);
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        updateOptionAvailability();
      }

      optionSelectors.forEach((selector, changedIndex) => {
        selector.addEventListener('change', () => {
          const values = selectedValues();
          let variant = variantForValues(values);

          if (!variant) {
            variant = variants.find((item) => item.available && item.options[changedIndex] === values[changedIndex])
              || variants.find((item) => item.options[changedIndex] === values[changedIndex]);
          }

          if (variant) selectVariant(variant);
        });
      });

      updateOptionAvailability();
    }

    function initialiseGallery(gallery) {
      if (gallery.dataset.initialized === 'true') return;

      const stage = gallery.querySelector('[data-gallery-stage]');
      const thumbnails = gallery.querySelector('[data-gallery-thumbnails]');
      const panels = [...gallery.querySelectorAll('.product-gallery__media[data-media-id]')];
      const buttons = [...gallery.querySelectorAll('[data-gallery-thumbnail]')];
      if (!stage || !panels.length || !buttons.length) return;

      gallery.dataset.initialized = 'true';

      const mediaIds = panels.map((panel) => panel.dataset.mediaId);
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let activeIndex = Math.max(0, panels.findIndex((panel) => !panel.hidden));
      let pointerStart = null;

      function activateMedia(mediaId, shouldFocus) {
        const nextIndex = mediaIds.indexOf(String(mediaId));
        if (nextIndex === -1) return;

        activeIndex = nextIndex;
        panels.forEach((panel, index) => {
          panel.hidden = index !== activeIndex;
          if (index !== activeIndex) {
            panel.querySelectorAll('video').forEach((video) => video.pause());
          }
        });
        buttons.forEach((button, index) => {
          if (index === activeIndex) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });

        const activeButton = buttons[activeIndex];
        if (activeButton && thumbnails) {
          activeButton.scrollIntoView({
            behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'nearest',
          });
          if (shouldFocus) activeButton.focus({ preventScroll: true });
        }
      }

      buttons.forEach((button) => {
        button.addEventListener('click', () => activateMedia(button.dataset.mediaId, false));
        button.addEventListener('keydown', (event) => {
          let nextIndex = activeIndex;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex -= 1;
          else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex += 1;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = buttons.length - 1;
          else return;

          event.preventDefault();
          nextIndex = (nextIndex + buttons.length) % buttons.length;
          activateMedia(mediaIds[nextIndex], true);
        });
      });

      gallery.querySelectorAll('[data-gallery-scroll]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!thumbnails) return;
          const direction = button.dataset.galleryScroll === 'next' ? 1 : -1;
          thumbnails.scrollBy({
            left: direction * Math.max(thumbnails.clientWidth * 0.8, 240),
            behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
          });
        });
      });

      stage.addEventListener('pointerdown', (event) => {
        if (event.target.closest('video, iframe, model-viewer')) return;
        pointerStart = { id: event.pointerId, x: event.clientX };
      });

      stage.addEventListener('pointerup', (event) => {
        if (!pointerStart || pointerStart.id !== event.pointerId || event.target.closest('video, iframe, model-viewer')) return;
        const distance = event.clientX - pointerStart.x;
        pointerStart = null;
        if (Math.abs(distance) < 40) return;
        const nextIndex = (activeIndex + (distance < 0 ? 1 : -1) + panels.length) % panels.length;
        activateMedia(mediaIds[nextIndex], false);
      });

      stage.addEventListener('pointercancel', () => {
        pointerStart = null;
      });

      const section = gallery.closest('[data-product-section]');
      const select = section?.querySelector('[data-variant-select]');
      const variantData = section?.querySelector('[data-product-variants]');
      if (!select || !variantData) return;

      let variants;
      try {
        variants = JSON.parse(variantData.textContent);
      } catch (error) {
        return;
      }

      select.addEventListener('change', () => {
        const variant = variants.find((item) => String(item.id) === select.value);
        if (variant?.featured_media_id) activateMedia(variant.featured_media_id, false);
      });
    }

    function initialise(root) {
      if (root.matches?.('[data-product-section]')) initialiseVariantPicker(root);
      root.querySelectorAll?.('[data-product-section]').forEach(initialiseVariantPicker);
      if (root.matches?.('[data-product-gallery]')) initialiseGallery(root);
      root.querySelectorAll?.('[data-product-gallery]').forEach(initialiseGallery);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
    else initialise(document);
    document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
